module.exports = new __parcel__URL__("pages-multimedia-darkmode.34e20d36.svg").toString();